import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedComponent() {
  const auth = localStorage.getItem("sansadToken");

  return <div>{auth ? <Outlet /> : <Navigate to="/admin-panel/login" />}</div>;
}
